export default {
  MENU: {
    GET_ALL_MENUS: 'GET_ALL_MENUS',
    SET_APPS: 'SET_APPS',
    ADD_MENU_OPTION: 'ADD_MENU_OPTION',
    ADD_MENU: 'ADD_MENU',
    REMOVE_MENU_OPTION: 'REMOVE_MENU_OPTION',
    UPDATE_MENU_FIELD: 'UPDATE_MENU_FIELD',
    SET_A_MENU: 'SET_A_MENU',
    EDIT_MENU: 'EDIT_MENU',
    EDIT_MENU_OPTION: 'EDIT_MENU_OPTION'
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/mutation-types.js